import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import "../../style/Project.css";

import bookly from "../../Assets/Projects/bookly.png";
import empress from "../../Assets/Projects/empress.jpg";
import goResilience from "../../Assets/Projects/go-resilience.png";
import nasa from "../../Assets/Projects/nasa.png";
import spark from "../../Assets/Projects/spark.png";
import yaoyiw from "../../Assets/Projects/yaoyiw.gif";

function Projects() {
  const [hoveredProject, setHoveredProject] = useState(null);

  const projects = [
    {
      id: 1,
      title: "Empress of Japan",
      type: "Cloud Infrastructure",
      description: "AWS infrastructure for a RAG-based museum exhibit app.",
      href: "https://d2kekuy8p1ofvv.cloudfront.net",
      image: empress
    },
    {
      id: 2,
      title: "Go Resilience Patterns",
      type: "Distributed Systems",
      description: "Circuit breaker, bulkhead, and fail fast measured against a cascading failure.",
      href: "https://github.com/YaoyiW27/go-resilience-patterns",
      image: goResilience
    },
    {
      id: 3,
      title: "Bookly",
      type: "Full-Stack Web",
      description: "Online book community with search, bookmarks, and discussion features.",
      href: "https://www.youtube.com/watch?v=uZTijQpb6hA",
      image: bookly
    },
    {
      id: 4,
      title: "Spark",
      type: "Mobile App",
      description: "Mobile social app for nearby discovery, matching, and shared moments.",
      href: "https://youtu.be/dpLnQXJyLyc",
      image: spark
    },
    {
      id: 5,
      title: "Cosmic Explorer",
      type: "Data & Visualization",
      description: "NASA visualization app for astronomy photos and Earth imagery.",
      href: "https://cs5001-cosmos.streamlit.app/",
      image: nasa
    },
    {
      id: 6,
      title: "Personal Portfolio",
      type: "Front-End",
      description: "A personal website showcasing my projects, resume, and GitHub activity.",
      href: "https://yaoyiw.netlify.app/",
      image: yaoyiw
    }
  ];

  return (
    <section className="project-section">
      <Container>
        <div className="project-header">
          <h1>My Projects</h1>
          <p className="project-subheading">Selected Projects</p>
          <div className="project-divider">
            <span></span>
          </div>
        </div>

        <div className="projects-grid">
          {projects.map((project) => (
            <a
              key={project.id}
              className="project-item"
              href={project.href}
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setHoveredProject(project.id)}
              onMouseLeave={() => setHoveredProject(null)}
            >
              <div className={`project-content ${hoveredProject === project.id ? 'hovered' : ''}`}>
                <h3 className="project-title">{project.title}</h3>
                <div className="project-type-wrapper">
                  <div className="project-type">{project.type}</div>
                </div>
                <p className="project-description">{project.description}</p>
                <div className="project-arrow">
                  <BsArrowRight />
                </div>
              </div>
              {project.image && (
                <div className={`project-image ${hoveredProject === project.id ? 'visible' : ''}`}>
                  <img src={project.image} alt={project.title} loading="lazy" />
                </div>
              )}
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default Projects;
